import { render } from "./SectionMedaillon.vue?vue&type=template&id=105b0d44"
import script from "./SectionMedaillon.vue?vue&type=script&lang=js"
export * from "./SectionMedaillon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__